// eslint-disable
// This file is generated dynamically through `node prepare-locales.js`. Please do content changes in `shopify/assets/locales/*.json`, update the filter rules in `prepare-locales.js` and run `node prepare-locales.js`.

export type Locale = {
  general: {
    countdown: {
      remaining: string
      days: string
      hours: string
      minutes: string
      seconds: string
    }
    forms: {
      inputs: {
        labels: {
          email: string
          firstName: string
          lastName: string
        }
        placeholders: {
          email: string
          firstName: string
          lastName: string
        }
        errors: {
          email: string
          firstName: string
          lastName: string
        }
      }
      response: {
        error: {
          text: string
        }
        success: {
          text: (data: { firstname: string; subject: string }) => string
        }
      }
      privacy_policy: string
      contact_information: string
    }
    links: {
      go_to: {
        product: (data: { productTitle: string }) => string
        link: (data: { linkTitle: string }) => string
      }
    }
  }
  brevo_form: {
    success: {
      title: string
      text: string
    }
    error: {
      title: string
      text: string
    }
  }
  accessibility: {
    close_notification: string
  }
  products: {
    product: {
      options: {
        more_single: string
        more_plural: string
      }
      option_name: {
        pack: string
        pack_number: {
          '1_html': string
          '3_html': string
          '6_html': string
          '12_html': string
          '24_html': string
          default_html: (data: { count: string }) => string
        }
        discount_html: (data: { percent: string }) => string
      }
      colli_label: {
        default_html: (data: { count: string }) => string
      }
      add_to_cart: string
      add_to_cart_sm: string
      add_to_cart_title: (data: { productTitle: string }) => string
      new: string
      quantity: {
        input_label: (data: { product: string }) => string
        increase: (data: { product: string }) => string
        decrease: (data: { product: string }) => string
        limit_reached_error: (data: {
          totalRequestedQuantity: string
          maxAvailable: string
        }) => string
        limit_reached_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          availableMultipackQuantity: string
          maxAvailable: string
        }) => string
        limit_reached_with_cart_items_error: (data: {
          requestedQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) => string
        limit_reached_with_cart_items_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) => string
        minimum_quantity_error: (data: { min: string }) => string
      }
      price: {
        from: string
      }
      sold_out: string
      diet_disclaimer: string
      sugar_disclaimer: string
      salt_disclaimer: string
      nutrient_data: {
        title: string
        'title-average': string
        'per-unit': string
        caloricvalue: string
        fat: string
        fat_of_which_saturates: string
        fat_of_which_mono_unsaturates: string
        carbohydrate: string
        carbohydrate_of_which_sugars: string
        carbohydrate_of_which_polyols: string
        carbohydrate_of_which_starch: string
        fibre: string
        protein: string
        salt: string
        vitamin_e: string
        potassium: string
        chloride: string
        calcium: string
        phosphorus: string
        omega_3_fatty_acids: string
        magnesium: string
        iron: string
        zinc: string
        copper: string
        manganese: string
        fluoride: string
        selenium: string
        chromium: string
        molybdenum: string
        iodine: string
        fat_of_which_polyunsaturates: string
        vitamin_a: string
        vitamin_d: string
        vitamin_k: string
        vitamin_c: string
        thiamin: string
        riboflavin: string
        niacin: string
        vitamin_b6: string
        folic_acid: string
        vitamin_b12: string
        biotin: string
        pantothenic_acid: string
      }
      'filter-p-m-seeberger-diet': {
        label: string
        'gluten-free': string
        'lactose-free': string
        vegan: string
        vegetarian: string
        'no-added-sugar': string
        'no-added-salt': string
      }
    }
    facets: {
      filter_by_label: (data: { filter: string }) => string
    }
  }
  sections: {
    cart: {
      remove_title: (data: { title: string }) => string
      free_gifts: {
        button_label: string
        select_label: string
        available_title: string
        available_title_numbered: (data: { number: string }) => string
        available_text: string
        change_label: string
        badge_label: string
        progress_bar_label: (data: { remainingMoney: string }) => string
      }
      multipack_discount_hint: {
        tag_next: string
        active_text: (data: { percent: string; count: string }) => string
        next_text: (data: { percent: string; count: string }) => string
      }
    }
    'sb-popup-variant-overlay': {
      select_option: string
      select_option_zustand: string
      select_option_inhalt: string
      select_option_packung: string
      title: string
    }
    lp_nutrient_wheel: {
      tabs_label: string
    }
  }
  localization: {
    language_switcher_title: string
    international: string
    country_section: string
    language_section: string
    country_section_desc: string
    language_section_desc: string
    redirect_title: string
    redirect_message: string
    non_order_options: string
  }
  'customer-favorites': {
    'add-to-favorites': string
    'remove-from-favorites': string
  }
  subscription: {
    discount_html: (data: { value: string }) => string
  }
}

if (!window.seebergerLocales) {
  window.seebergerLocales = {}
}

window.seebergerLocales.en = {
  general: {
    countdown: {
      remaining: 'Time remaining',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
      seconds: 'Seconds',
    },
    forms: {
      inputs: {
        labels: {
          email: 'Email',
          firstName: 'First Name',
          lastName: 'Last Name',
        },
        placeholders: {
          email: 'e.g., mali.example@example.com',
          firstName: 'e.g., Mali',
          lastName: 'e.g., Example',
        },
        errors: {
          email: 'Please fill out Email.',
          firstName: 'Please fill out First Name.',
          lastName: 'Please fill out Last Name.',
        },
      },
      response: {
        error: {
          text: 'Please check your input and try again. The following fields have errors: ',
        },
        success: {
          text: (data: { firstname: string; subject: string }) =>
            `Thank you for your message, ${data.firstname}. We will get back to you as soon as possible regarding "${data.subject}".`,
        },
      },
      privacy_policy: 'Privacy Policy',
      contact_information: 'Contact Information',
    },
    links: {
      go_to: {
        product: (data: { productTitle: string }) =>
          `Get more information about ${data.productTitle}`,
        link: (data: { linkTitle: string }) => `More about ${data.linkTitle}`,
      },
    },
  },
  brevo_form: {
    success: {
      title: 'Thanks for signing up',
      text: 'Please check your inbox (including spam) to confirm your registration.',
    },
    error: {
      title: 'An error occurred',
      text: 'Please deactivate your AdBlocker and check your internet connection.',
    },
  },
  accessibility: {
    close_notification: 'Close notification',
  },
  products: {
    product: {
      options: {
        more_single: 'Further',
        more_plural: 'More',
      },
      option_name: {
        pack: 'Pack',
        pack_number: {
          '1_html': 'Single product',
          '3_html': 'Pack of 3',
          '6_html': 'Pack of 6',
          '12_html': 'Pack of 12',
          '24_html': 'Pack of 24',
          default_html: (data: { count: string }) => `Pack of ${data.count}`,
        },
        discount_html: (data: { percent: string }) => `Save ${data.percent}%`,
      },
      colli_label: {
        default_html: (data: { count: string }) => `${data.count} pcs`,
      },
      add_to_cart: 'Add to cart',
      add_to_cart_sm: 'Add to cart',
      add_to_cart_title: (data: { productTitle: string }) =>
        `Add ${data.productTitle} to cart`,
      new: 'New',
      quantity: {
        input_label: (data: { product: string }) =>
          `Quantity for ${data.product}`,
        increase: (data: { product: string }) =>
          `Increase quantity for ${data.product}`,
        decrease: (data: { product: string }) =>
          `Decrease quantity for ${data.product}`,
        limit_reached_error: (data: {
          totalRequestedQuantity: string
          maxAvailable: string
        }) =>
          `The requested quantity of ${data.totalRequestedQuantity} is not available. The maximum available quantity is ${data.maxAvailable}.`,
        limit_reached_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          availableMultipackQuantity: string
          maxAvailable: string
        }) =>
          `The requested quantity of ${data.multiplicator}x${data.multipackQuantity} is not available. The maximum available multipacks are ${data.availableMultipackQuantity}x${data.multipackQuantity} or ${data.maxAvailable} single products.`,
        limit_reached_with_cart_items_error: (data: {
          requestedQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `The requested quantity of ${data.requestedQuantity} is not available, as there are already ${data.cartItemsCount} items in your cart. The total available quantity is ${data.maxAvailable}.`,
        limit_reached_with_cart_items_multipack_error: (data: {
          multiplicator: string
          multipackQuantity: string
          cartItemsCount: string
          maxAvailable: string
        }) =>
          `The requested quantity of ${data.multiplicator}x${data.multipackQuantity} is not available, as there are already ${data.cartItemsCount} items in your cart. The total available quantity of single products is ${data.maxAvailable}.`,
        minimum_quantity_error: (data: { min: string }) =>
          `You must order at least ${data.min} items.`,
      },
      price: {
        from: 'From',
      },
      sold_out: 'Sold out',
      diet_disclaimer: 'According to recipe, cross-contamination possible.',
      sugar_disclaimer: 'Contains naturally occurring sugars.',
      salt_disclaimer: 'Contains naturally occurring salt. ',
      nutrient_data: {
        title: 'Nutrient facts',
        'title-average': 'Average nutritional values',
        'per-unit': '100g',
        caloricvalue: 'Caloric value (in kj/kcal)',
        fat: 'Fats',
        fat_of_which_saturates: 'Of which saturated fats',
        fat_of_which_mono_unsaturates: 'Of which monounsaturated fatty acids',
        carbohydrate: 'Carbohydrates',
        carbohydrate_of_which_sugars: 'Of which sugars',
        carbohydrate_of_which_polyols: 'Of which polyols',
        carbohydrate_of_which_starch: 'Of which starch',
        fibre: 'Fibre',
        protein: 'Protein',
        salt: 'Salt',
        vitamin_e: 'Vitamine E',
        potassium: 'Potassium',
        chloride: 'Chloride',
        calcium: 'Calcium',
        phosphorus: 'Phosphorus',
        omega_3_fatty_acids: 'Omega 3 Fats',
        magnesium: 'Magnesium',
        iron: 'Iron',
        zinc: 'Zinc',
        copper: 'Copper',
        manganese: 'Manganese',
        fluoride: 'Fluoride',
        selenium: 'Selenium',
        chromium: 'Chromium',
        molybdenum: 'Molybdenum',
        iodine: 'Iodine',
        fat_of_which_polyunsaturates: 'Of which polyunsaturated fatty acids',
        vitamin_a: 'Vitamin A',
        vitamin_d: 'Vitamin D',
        vitamin_k: 'Vitamin K',
        vitamin_c: 'Vitamin C',
        thiamin: 'Thiamin',
        riboflavin: 'Riboflavin',
        niacin: 'Niacin',
        vitamin_b6: 'Vitamin B6',
        folic_acid: 'Folic acid',
        vitamin_b12: 'Vitamin B12',
        biotin: 'Biotin',
        pantothenic_acid: 'Pantothenic acid',
      },
      'filter-p-m-seeberger-diet': {
        label: 'Diet',
        'gluten-free': 'gluten free',
        'lactose-free': 'lactose free',
        vegan: 'vegan',
        vegetarian: 'vegetarian',
        'no-added-sugar': 'no added sugar',
        'no-added-salt': 'no added salt',
      },
    },
    facets: {
      filter_by_label: (data: { filter: string }) => `Filter by ${data.filter}`,
    },
  },
  sections: {
    cart: {
      remove_title: (data: { title: string }) => `Remove ${data.title}`,
      free_gifts: {
        button_label: 'Choose gift',
        select_label: 'Select',
        available_title: 'Your gift is waiting for you',
        available_title_numbered: (data: { number: string }) =>
          `Your gift no. ${data.number} is waiting for you`,
        available_text: 'Choose your free gift now.',
        change_label: 'Change',
        badge_label: 'Free gift',
        progress_bar_label: (data: { remainingMoney: string }) =>
          `Only ${data.remainingMoney} away from a free gift.`,
      },
      multipack_discount_hint: {
        tag_next: 'Save tip',
        active_text: (data: { percent: string; count: string }) =>
          `-${data.percent}% from ${data.count} pcs`,
        next_text: (data: { percent: string; count: string }) =>
          `-${data.percent}% from ${data.count} pcs`,
      },
    },
    'sb-popup-variant-overlay': {
      select_option: 'Please select the {option}',
      select_option_zustand: 'Whole or ground?',
      select_option_inhalt: 'How much can it be?',
      select_option_packung: 'How many packages?',
      title: '',
    },
    lp_nutrient_wheel: {
      tabs_label: 'Select a nutrient',
    },
  },
  localization: {
    language_switcher_title: 'Language switcher',
    international: 'International',
    country_section: 'Delivery Country',
    language_section: 'Languages',
    country_section_desc: 'Choose the country where your delivery should go.',
    language_section_desc:
      'Choose your preferred language in which content will be displayed.',
    redirect_title: 'Redirecting',
    redirect_message:
      'You will be redirected to the selected language version %selection% shortly.',
    non_order_options: 'Selection without order options',
  },
  'customer-favorites': {
    'add-to-favorites': 'Add to favorites',
    'remove-from-favorites': 'Remove from favorites',
  },
  subscription: {
    discount_html: (data: { value: string }) => `Save ${data.value}`,
  },
} satisfies Locale
